export const dmc = {
  companyName: 'FlySync',
  corporateName: 'DMCLeisure',
  title: 'DMC Leisure',
  templateConfig: 'template2',
  email: 'worldofwow@dmcleisure.com',
  phone: '+91 8137003508',
  address:
    '<div><strong>Ghatala Towers</strong>, <br>Avenue Rd, Ponnangipuram, Tirumurthy Nagar, Nungambakkam, Chennai, Tamil Nadu 600034</div>',
  apiUrl: 'https://businesstravel.dmcleisure.com/backend/',
  isFullBGimage: 'Y',
  whatsapp: '',
  isHotel: false,
  poweredBy: true,
  agentNavigate: 'https://businesstravel.dmcleisure.com/auth/login',
  instagram: 'https://www.instagram.com/dmc_leisure/?hl=en',
  facebook: 'https://www.facebook.com/p/DMC-Leisure-100063835486401/',
  twitter: '',
  linkedin: 'https://www.linkedin.com/company/dmc-leisure/',
  youtube: 'https://www.youtube.com/@dmcleisure5704',
  sentryDsn:
    'https://67269001d7387ce208d73a9eb29708e3@o4509110763126784.ingest.us.sentry.io/4509110770663424',
  registerAddress: '',
  registerCompanyName: '',
  registerEmail: '',
  registerMobile: '',
  registerNo: '',
  providerCodes: ['INV', 'TJ'],
  cancellationCharges: '{"DO":"250","IN":"500"}',
  encrypt: 'N',
  securePayment: 'true',
  encryptionSecretKey: 'd1e622507595486ee06db24b1debf11064edd2ba',
};
